<template>
  <div class="aboutpage">
    About the Author stuff here
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "AboutPage",
  methods: {},
  data() {
    return {};
  },
};
</script>
